<div class="qa-loader-spinner text-center" role="status">
  <i class="fal fa-spinner-third fa-5x fa-fw fa-spin" aria-hidden="true"></i>
  <span class="sr-only" i18n="@@loader-spinner-loading">Loading...</span>
</div>
